"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _shallowequal = _interopRequireDefault(require("shallowequal"));

var isShallowEquals = function isShallowEquals(a, b) {
  if (!Array.isArray(a) || !Array.isArray(b)) {
    return (0, _shallowequal.default)(a, b);
  }

  if (a.length !== b.length) {
    return false;
  }

  for (var key = 0; key < a.length; key += 1) {
    if (!(key in b)) {
      return false;
    }

    if (!(0, _shallowequal.default)(a[key], b[key])) {
      return false;
    }
  }

  return true;
};

var _default = isShallowEquals;
exports.default = _default;